export default __webpack_public_path__ + "static/media/December2019.16d51191.png";